import React from 'react';
import { Link } from 'react-router-dom';
import siteConfig from '../data/siteConfig.json';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative border-t border-white/5 py-16 md:py-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Large Brand */}
        <div className="mb-16">
          <Link to="/" className="inline-flex items-center gap-4 group">
            <img
              src={siteConfig.brand.logo}
              alt="ROMIND"
              className="h-12 w-12 transition-transform duration-300 group-hover:scale-110"
            />
            <span className="text-4xl md:text-5xl font-bold tracking-tight gradient-text">
              {siteConfig.brand.name}
            </span>
          </Link>
          <p className="mt-4 text-slate-400 max-w-md">
            {siteConfig.brand.tagline}
          </p>
        </div>

        {/* Navigation Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              Product
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/features" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/use-cases" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Use Cases
                </Link>
              </li>
              <li>
                <Link to="/updates" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Updates
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              Company
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/press" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Press
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              Support
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/faq" className="text-slate-400 hover:text-white transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <a href="#early-access" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Early Access
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              Legal
            </h4>
            <ul className="space-y-3">
              {siteConfig.footer.links.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-slate-400 hover:text-white transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} {siteConfig.footer.copyright}
          </p>
          <p className="text-slate-600 text-xs">
            Cognitive Presence System
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
